/* eslint-disable no-console */
import firebase from 'firebase/app'
import 'firebase/firebase-firestore'
import 'firebase/functions'
import * as constants from '../../../constants.json'

export default {
  /**
   * Properties from the app state.
   * @property {array} state.user        - The user object.
   */
  state: {
    autoSignInFlag: true,
    facebookSignInLoading: false,
    user: null,
    loadedCollabs: [],
    closeDialog: false,
    openSignInDialog: false,
    openSignUpDialog: false
  },

  mutations: {
    /**
     * Mutation method that loads the user object to the state.
     * @param {*} state         - The state property.
     * @param {object} payload  - The user object.
     */
    mutationSetUser (state, payload) {
      state.user = payload
    },

    /**
     * Mutation method that add the collab object to the state.
     * @param {*} state         - The state property.
     * @param {object} payload  - The collab object.
     */
    mutationAddCollab (state, collab) {
      state.loadedCollabs.push(collab)
    },

    /**
     * Mutation method that loads the collaborators array to state.
     * @param {*} state
     * @param {*} collabs Array of collaborators.
     */
    mutationLoadCollabs (state, collabs) {
      console.log(collabs)
      state.loadedCollabs = [...collabs]
    },

    /**
     * Mutation method that update the collab object.
     * @param {object} state    - The state property.
     * @param {object} user  - The companyId and user object.
     */
    mutationUpdateCollab (state, payload) {
      console.log(payload)
      console.log(state.loadedCollabs.findIndex(collab => collab.collabId === payload.collabId))
      state.loadedCollabs[state.loadedCollabs.findIndex(collab => collab.collabId === payload.collabId)] = payload
    },

    /**
     * Mutation method to delete a collab object.
     * @param {*} state    The state property.
     * @param {*} collabId The id of the collab doc.
     */
    mutationDeleteCollab (state, collabId) {
      state.loadedCollabs.splice(state.loadedCollabs.findIndex(collab => collab.collabId === collabId), 1)
    },

    /**
     * Mutation method to disable auto sign in.
     * @param {*} state    The state property.
     * @param {*} payload  Boolean.
     */
    mutationAutoSignInFlag (state, payload) {
      state.autoSignInFlag = payload
    },

    /**
     * Mutation method to open the sign in dialog
     * @param {*} state    The state property.
     * @param {*} payload  Boolean.
     */
    mutationOpenSignInDialog (state, payload) {
      state.openSignInDialog = payload
    },

    /**
     * Mutation method to open the sign up dialog
     * @param {*} state    The state property.
     * @param {*} payload  Boolean.
     */
    mutationOpenSignUpDialog (state, payload) {
      state.openSignUpDialog = payload
    }
  },

  actions: {
    /**
     * Create a new user
     * @param {*} param0   - The commit object.
     * @param {*} payload  - Properties: companyId, companyName, creationDate, email,
     * firstName, lastName, phone, photoUrl, role and creationDate.
     */
    async actionCreateNewCollab ({ commit }, payload) {
      console.log('creating new collab')
      commit('mutationSetLoading', true)
      try {
        console.log('payload: ', payload)
        // Sign user up with email
        const userCredential = await firebase.auth().createUserWithEmailAndPassword(payload.email, payload.password)

        // Create user doc

        const newUser = {
          companyId: '',
          companyName: '',
          companyPhotoUrl: '',
          email: payload.email,
          firstName: payload.firstName,
          lastName: payload.lastName,
          password: payload.password,
          phone: payload.phone,
          photoUrl: payload.photoUrl,
          role: 'editor',
          collabId: userCredential.user.uid,
          creationDate: new Date()
        }
        const userToMutation = {
          companyId: '',
          companyName: '',
          email: payload.email,
          firstName: payload.firstName,
          id: userCredential.user.uid,
          photoUrl: '',
          role: 'editor'
        }
        await firebase
          .firestore()
          .collection('users')
          .doc(userCredential.user.uid)
          .set(newUser)

        commit('mutationSetUser', userToMutation)
        commit('mutationSetLoading', false)
        commit('mutationOpenSignUpDialog', false)
      } catch (error) {
        commit('mutationSetLoading', false)
        throw error
      }
    },

    /**
     * Update the user doc
     * @param {*} param0   - The commit object.
     * @param {*} payload  - Properties: companyId, companyName, creationDate, email,
     * firstName, lastName, phone, photoUrl, role and creationDate.
     */
    async actionUpdateCollab ({ commit }, payload) {
      console.log('updating collab')
      commit('mutationSetLoading', true)
      try {
        console.log('payload: ', payload)

        const updatedCollab = {
          firstName: payload.firstName,
          lastName: payload.lastName,
          phone: payload.phone,
          photoUrl: payload.photoUrl
        }

        // Create user doc
        const toMutation = {
          companyId: payload.companyId,
          companyName: 'payload.companyName',
          email: payload.email,
          firstName: payload.firstName,
          lastName: payload.lastName,
          password: payload.password,
          phone: payload.phone,
          photoUrl: payload.photoUrl,
          role: payload.role,
          collabId: payload.collabId,
          creationDate: payload.creationDate
        }

        // Update user doc
        await firebase
          .firestore()
          .collection('users')
          .doc(payload.collabId)
          .update(updatedCollab)

        commit('mutationUpdateCollab', { ...toMutation })
        commit('mutationSetLoading', false)
      } catch (error) {
        commit('mutationSetLoading', false)
        throw error
      }
    },

    async actionAddCollab ({ commit }, payload) {
      try {
        console.log('Adding colab: ', payload)
        commit('mutationSetLoading', true)

        const batch = firebase.firestore().batch()

        // Search collab doc
        const collabRef = firebase
          .firestore()
          .collection('users')
          .doc(payload.collabId)

        const collabDoc = await collabRef.get()

        if (collabDoc.exists) {
          // Add company Id and name to collab doc.
          batch.update(collabRef, {
            companyId: payload.companyId,
            companyName: payload.companyName,
            companyPhotoUrl: payload.companyPhotoUrl
          })

          // Add email to bot's emails list.
          const botRef = firebase
            .firestore()
            .collection('companies')
            .doc(payload.companyId)
            .collection('bots')
            .doc(constants.BOT_ID)

          const botDoc = await botRef.get()
          const emails = botDoc.data().emails

          emails.push(collabDoc.data().email)

          batch.update(botRef, { emails })

          await batch.commit()

          const collab = {
            companyId: payload.companyId,
            companyName: payload.companyName,
            creationDate: collabDoc.data().creationDate,
            email: collabDoc.data().email,
            firstName: collabDoc.data().firstName,
            lastName: collabDoc.data().lastName,
            password: collabDoc.data().password,
            phone: collabDoc.data().phone,
            photoUrl: collabDoc.data().photoUrl,
            role: collabDoc.data().role,
            collabId: collabDoc.data().collabId
          }

          commit('mutationAddCollab', collab)
          commit('mutationSetLoading', false)
        } else {
          commit('mutationSetLoading', false)
          throw new Error('El ID del colaborador no existe.')
        }
      } catch (error) {
        commit('mutationSetLoading', false)
        throw error
      }
    },

    /**
     * Load the collaborators
     * @param {*} param0
     * @param {*} payload
     */
    async actionLoadCollabs ({ commit }, payload) {
      try {
        console.log('Loading collabs: ', payload)
        commit('mutationSetLoading', true)
        const collabs = []
        const queryCollabs = await firebase
          .firestore()
          .collection('users')
          .where('companyId', '==', payload.companyId)
          .orderBy('firstName')
          .get()

        if (!queryCollabs.empty) {
          for (const collab of queryCollabs.docs) {
            if (collab.data().role !== 'administrator') {
              collabs.push({
                companyId: collab.data().companyId,
                companyName: collab.data().companyName,
                creationDate: collab.data().creationDate,
                email: collab.data().email,
                firstName: collab.data().firstName,
                lastName: collab.data().lastName,
                password: collab.data().password,
                phone: collab.data().phone,
                photoUrl: collab.data().photoUrl,
                role: collab.data().role,
                collabId: collab.data().collabId
              })
            }
          }
          console.log('collabs: ', collabs)
          commit('mutationLoadCollabs', collabs)
        }
        commit('mutationSetLoading', false)
      } catch (error) {
        commit('mutationSetLoading', false)
        throw error
      }
    },

    /**
     * Delete the user doc
     * @param {*} param0   - The commit object.
     * @param {*} payload  - Properties: companyId, userId,
     */
    async actionDeleteCollab ({ commit }, payload) {
      console.log('deleting user')
      commit('mutationSetLoading', true)

      console.log('payload: ', payload)
      try {
        const batch = firebase.firestore().batch()

        // Delete user
        const userRef = firebase
          .firestore()
          .collection('users')
          .doc(payload.collabId)

        batch.update(userRef, {
          companyId: '',
          companyName: '',
          companyPhotoUrl: ''
        })

        // Delete email from bot doc
        const botRef = firebase
          .firestore()
          .collection('companies')
          .doc(payload.companyId)
          .collection('bots')
          .doc(constants.BOT_ID)

        const botDoc = await botRef.get()
        const emails = botDoc.data().emails

        emails.splice(emails.findIndex(email => email === payload.email), 1)

        batch.update(botRef, { emails })

        await batch.commit()
        commit('mutationDeleteCollab', payload.collabId)
        commit('mutationSetLoading', false)
      } catch (error) {
        commit('mutationSetLoading', false)
        throw error
      }
    },

    /**
     * Sign user up with email
     * @param {object} payload  - Contains the following properties: email and password.
     */
    async actionSignUserUpEmail ({ commit }, payload) {
      commit('mutationSetLoading', true)
      commit('mutationClearError')
      try {
        const userCredential = await firebase.auth().createUserWithEmailAndPassword(payload.email, payload.password)

        const newUser = {
          id: userCredential.user.uid,
          name: userCredential.user.displayName
        }
        commit('mutationSetUser', newUser)
        commit('mutationSetLoading', false)
      } catch (error) {
        commit('mutationSetLoading', false)
        commit('mutationSetError', error)
        throw error
      }
    },

    /**
       * Sign user in with email
       * @param {object} payload  - Contains the following properties: email and password.
       */
    async actionSignUserInEmail ({ commit }, payload) {
      try {
        commit('mutationClearError')
        commit('mutationSetLoading', true)

        const userCredential = await firebase.auth().signInWithEmailAndPassword(payload.email, payload.password)

        commit('mutationSetLoading', false)
        commit('mutationOpenSignInDialog', false)

        console.log('userCredential', userCredential)
      } catch (error) {
        commit('mutationSetLoading', false)
        commit('mutationSetError', error)

        console.log(error)
      }
    },
    /**
     * Sign user in with Facebook
     */
    async actionFacebookLogin ({ commit }, payload) {
      try {
        console.log('Signing in with Facebook: ', payload)
        commit('mutationSetLoading', true)
        commit('mutationAutoSignInFlag', false)
        commit('mutationClearError')

        const isUserSignedIn = (facebookAuthResponse, firebaseUser) => {
          if (firebaseUser) {
            var providerData = firebaseUser.providerData
            for (var i = 0; i < providerData.length; i++) {
              if (providerData[i].providerId === firebase.auth.FacebookAuthProvider.PROVIDER_ID &&
                  providerData[i].uid === facebookAuthResponse.userID) {
                console.log('User already signed in')
                // We don't need to re-auth the Firebase connection.
                return true
              }
            }
          }
          return false
        }

        if (payload.event.status === 'connected') {
          console.log('event: ', payload.event)
          // User is signed-in Facebook.
          let unsubscribe = firebase.auth().onAuthStateChanged(async (firebaseUser) => {
            unsubscribe()
            console.log('firebaseUser: ', firebaseUser)

            // Check if we are already signed-in Firebase with the correct user.
            if (!isUserSignedIn(payload.event.authResponse, firebaseUser)) {
              // If not build Firebase credential with the Facebook auth token.
              let credential = firebase.auth.FacebookAuthProvider.credential(payload.event.authResponse.accessToken)

              // Sign in with the credential from the Facebook user.
              const user = await firebase.auth().signInWithCredential(credential)

              console.log('user signed in: ', user)

              const token = payload.event.authResponse.accessToken
              const fbUserId = payload.event.authResponse.userID

              let userToState = {}

              // Get list of user's facebook pages with access permission
              const genFbPageToken = firebase.functions().httpsCallable('genFbPageToken')
              const fbPageData = await genFbPageToken({
                user_access_token: token,
                user_id: fbUserId
              })

              console.log('fbPageData:', fbPageData.data)

              let batch = firebase.firestore().batch()

              // Save or update each page to a different company doc
              for (const page of fbPageData.data.response) {
                let companyRef = firebase
                  .firestore()
                  .collection('companies')
                  .doc(page.id)

                /**
                 *  Company doc
                 */
                // If company exists we update the doc, else we create a new one
                if ((await companyRef.get()).exists) {
                  console.log(`${page.name} doc exists, updating...`)
                  const updateCompany = {
                    name: page.name,
                    fbPageToken: page.access_token,
                    ownerPageTasks: page.ownerPageTasks,
                    photoUrl: page.photoUrl
                  }

                  batch.update(companyRef, updateCompany)
                } else {
                  // Create a new company doc
                  console.log(`Creating ${page.name} doc.`)
                  const addCompany = {
                    companyId: page.id,
                    companyName: page.name,
                    creationDate: new Date(),
                    fbPageToken: page.access_token,
                    ownerId: fbUserId,
                    ownerPageTasks: page.ownerPageTasks,
                    photoUrl: page.photoUrl,
                    subscribedLabel: page.subscribedLabel,
                    status: page.status
                  }

                  batch.set(companyRef, addCompany)

                  const addBot = {
                    creationDate: new Date(),
                    companyData: [],
                    emails: [payload.profile.email],
                    exRate: 0,
                    currency: '',
                    shippingCost: 0,
                    ordersCounter: 0
                  }

                  let botRef = firebase
                    .firestore()
                    .collection('companies')
                    .doc(page.id)
                    .collection('bots')
                    .doc(constants.BOT_ID)

                  batch.set(botRef, addBot)
                }
              }

              // Load first page id and name to localstorage and to state
              localStorage.companyId = fbPageData.data.response[0].id
              localStorage.companyName = fbPageData.data.response[0].name
              localStorage.companyPhotoUrl = fbPageData.data.response[0].photoUrl

              const firstCompany = await firebase
                .firestore()
                .collection('companies')
                .doc(fbPageData.data.response[0].id)
                .get()

              const companyData = {
                companyId: fbPageData.data.response[0].id,
                companyName: fbPageData.data.response[0].name,
                companyStatus: firstCompany.data().status,
                companyPhotoUrl: fbPageData.data.response[0].photoUrl
              }
              console.log({ companyData })
              commit('mutationSetCompanyData', companyData)

              /**
               * User doc
               */
              // Verify if user doc doesn't exist on db
              const userRef = firebase
                .firestore()
                .collection('users')
                .doc(user.user.uid)

              const userDoc = await userRef.get()

              if (!userDoc.exists) {
                // If user doc doen't exist create a new one
                console.log('Creating new user doc')

                const newUser = {
                  companies: fbPageData.data.response,
                  role: 'administrator',
                  creationDate: new Date(),
                  firstName: payload.profile.firstName,
                  lastName: payload.profile.lastName,
                  fullName: payload.profile.name,
                  facebookId: fbUserId,
                  email: payload.profile.email,
                  photoUrl: payload.profile.photoUrl,
                  uid: user.user.uid
                }

                console.log('newUser', newUser)

                batch.set(userRef, newUser)
              } else {
                // If user doc exists update the companies list
                console.log('User doc exists, updating...')

                batch.update(userRef, { companies: fbPageData.data.response })
              }

              // Load user to state
              userToState = {
                companies: fbPageData.data.response,
                email: payload.profile.email,
                firstName: payload.profile.firstName,
                id: user.user.uid,
                photoUrl: payload.profile.photoUrl,
                role: 'administrator'
              }

              commit('mutationSetUser', userToState)

              await batch.commit()
              console.log('loading off')
              commit('mutationSetLoading', false)
            }
          })
        } else {
          // User is signed-out of Facebook.
          firebase.auth().signOut()
          commit('mutationSetLoading', false)
        }
      } catch (error) {
        commit('mutationSetLoading', false)
        const errorCode = error.code
        const errorMessage = error.message
        if (errorCode === 'auth/network-request-failed') commit('mutationSetError', 'No tienes conexión a internet!')
        throw errorMessage
      }
    },

    /**
      * Log user out
      */
    async actionLogout ({ commit }) {
      try {
        console.log('Logging out')
        const companyData = {
          companyId: '',
          companyName: '',
          companyStatus: '',
          companyPhotoUrl: ''
        }

        localStorage.companyId = ''
        commit('mutationSetCompanyData', companyData)
        await firebase.auth().signOut()
        commit('mutationSetUser', null)
      } catch (error) {
        throw error
      }
    },

    /**
     * Auto Signing in
     */
    async actionAutoSignIn ({ commit, getters }, payload) {
      try {
        console.log('getAutoSignInFlag: ', getters.getAutoSignInFlag)
        if (getters.getAutoSignInFlag) {
          commit('mutationSetLoading', true)
          if (payload !== null && payload !== undefined) {
            console.log('payload: ', payload)

            // Verify if user exists
            const userDoc = await firebase
              .firestore()
              .collection('users')
              .doc(payload.id)
              .get()

            console.log('userData: ', userDoc.data())

            if (userDoc.exists) {
              console.log('User doc exists')

              // Verify if user role is administrator or editor
              let userData = {}
              if (userDoc.data().role === 'mega_administrator') {
                console.log('mega_administrator')
                // Load mega administrator data
                userData = {
                  email: payload.email,
                  id: payload.id,
                  role: userDoc.data().role
                }

                // Load the company data to state
                if (localStorage.companyId !== '' && localStorage.companyId !== undefined) {
                  const companyDoc = await firebase
                    .firestore()
                    .collection('companies')
                    .doc(localStorage.companyId)
                    .get()

                  const companyData = {
                    companyId: companyDoc.data().companyId,
                    companyName: companyDoc.data().companyName,
                    companyStatus: companyDoc.data().status,
                    companyPhotoUrl: companyDoc.data().photoUrl
                  }

                  commit('mutationSetCompanyData', companyData)
                }

                // Load user data to state
                commit('mutationSetUser', userData)
              } else if (userDoc.data().role === 'administrator') {
                // Load administrator data
                userData = {
                  companies: userDoc.data().companies,
                  email: userDoc.data().email,
                  firstName: userDoc.data().firstName,
                  id: payload.id,
                  photoUrl: userDoc.data().photoUrl,
                  role: userDoc.data().role
                }

                // Load the company data to state
                if (localStorage.companyId !== '') {
                  const companyDoc = await firebase
                    .firestore()
                    .collection('companies')
                    .doc(localStorage.companyId)
                    .get()

                  const companyData = {
                    companyId: companyDoc.data().companyId,
                    companyName: companyDoc.data().companyName,
                    companyStatus: companyDoc.data().status,
                    companyPhotoUrl: companyDoc.data().photoUrl
                  }

                  commit('mutationSetCompanyData', companyData)
                }

                // Load user data to state
                commit('mutationSetUser', userData)
              } else if (userDoc.data().role === 'editor') {
                // Load editor data
                userData = {
                  companyId: userDoc.data().companyId,
                  companyName: userDoc.data().companyName,
                  email: payload.email,
                  firstName: userDoc.data().firstName,
                  id: payload.id,
                  photoUrl: userDoc.data().companyPhotoUrl,
                  role: userDoc.data().role
                }
                // If editor has a company assigned load the data to local storage
                if (userDoc.data().companyId !== '') {
                  localStorage.companyId = userDoc.data().companyId
                  localStorage.companyName = userDoc.data().companyName
                  localStorage.companyPhotoUrl = userDoc.data().companyPhotoUrl
                } else {
                  // Load an empty company data to state
                  const companyData = {
                    companyId: '',
                    companyName: '',
                    companyStatus: '',
                    companyPhotoUrl: ''
                  }

                  commit('mutationSetUser', userData)
                  commit('mutationSetCompanyData', companyData)
                  commit('mutationSetLoading', false)
                  return
                }
              }

              commit('mutationSetLoading', false)
            } else {
              console.log('user doc is not created yet')
              commit('mutationSetLoading', false)
            }
          } else {
            commit('mutationSetLoading', false)
            commit('mutationSetUser', null)
          }
        }
      } catch (error) {
        commit('mutationSetLoading', false)
        throw error
      }
    }
  },

  getters: {
    /**
     * @returns the user object from the state.
     */
    getUser (state) {
      return state.user
    },

    /**
     * @returns the loaded collaborators object
     */
    getLoadedCollabs (state) {
      return state.loadedCollabs
    },

    /**
     * @returns the AutoSignInFlag
     */
    getAutoSignInFlag (state) {
      return state.autoSignInFlag
    },

    /**
     * @returns the openSignInDialog
     */
    getOpenSignInDialog (state) {
      return state.openSignInDialog
    },

    /**
     * @returns the openSignInDialog
     */
    getOpenSignUpDialog (state) {
      return state.openSignUpDialog
    }
  }
}
